import api from "@/libs/axios";

export default {
  async create(payload) {
    const response = await api.post("/admin/social-game/create-word", payload);
    return response || null;
  },

  async update(payload) {
    let response = await api.put("/admin/social-game/create-word", payload);
    return response;
  },

  async delete(payload) {
    const response = await api.delete("/admin/social-game/create-word", {
      data: payload
    });
    return response;
  },

  async getList(params) {
    let response = await api.get("/admin/social-game/create-word", {
      params
    });
    return response.data.data;
  },

  async get(params) {
    let response = await api.get("/admin/social-game/create-word/detail", {
      params
    });
    return response.data.data.document || null;
  },
  async import(payload) {
    let response = await api.post(
      "/admin/social-game/create-word/import",
      payload
    );
    return response;
  },
  async replace(payload) {
    let response = await api.post(
      "/admin/social-game/create-word/replace",
      payload
    );
    return response;
  }
};
